"use client"

import NewPostButton from "@/app/(app)/(paragraph)/dashboard/components/NewPostButton"
import { usePathname } from "next/navigation"

export default function NewPostButtonWrapper({
  blogSlug,
  customDomain,
  isLoggedIn,
}: {
  blogSlug: string
  customDomain?: string
  isLoggedIn: boolean
}) {
  const isHome = usePathname()?.startsWith("/home")

  if (isHome && isLoggedIn) {
    return (
      <NewPostButton
        source="home"
        blogSlug={blogSlug}
        customDomain={customDomain}
      />
    )
  }

  return null
}
